import Login from './pages/login/login.vue'
import Referral from './pages/referral/referral.vue'
import information from './pages/information/information.vue'
import protocol from './pages/protocol/protocol.vue'

export default [
  { path: '/login', component: Login },
  { path: '/referral', component: Referral },
  { path: '/information', component: information },
  { path: '/protocol', component: protocol },
  { path: '/', redirect: { path: '/referral' } },
  { path: '/*', redirect: { path: '/referral' } }
]



// WEBPACK FOOTER //
// ./src/router-config.js